module.exports = __webpack_public_path__ + "static/recruit.c057e2cf.png";